import React from 'react';
import { Form, Alert } from 'antd';
import { useCanChangePaymentState } from '../../model/globalState';
import PriceField from '../PriceField';
import { useModalContentProps } from '../../model/state';
import PaymentTypesField from '../PaymentTypesField';
import { fieldNames } from '../../config/form';

const PaymentTypesContent = ({ getFieldValue, ...props }) => {
  const isFinal = !getFieldValue(fieldNames.priceData)?.isNotFinal;

  return isFinal ? (
    <PaymentTypesField {...props} />
  ) : (
    <Alert
      message="Чтобы выбрать способы оплаты, указанная сумма должна быть окончательной"
      type="info"
      showIcon
    />
  );
};

const InvoiceAndTypesForm = ({ form, className }) => {
  const { getFieldDecorator, getFieldValue } = form;

  const canChangePaymentState = useCanChangePaymentState();

  const { entity } = useModalContentProps();

  return (
    <Form
      colon={false}
      className={className}
    >
      <PriceField
        getFieldDecorator={getFieldDecorator}
        invoice={entity?.invoice}
      />
      {canChangePaymentState && (
        <PaymentTypesContent
          getFieldValue={getFieldValue}
          getFieldDecorator={getFieldDecorator}
          id={entity?.id}
        />
      )}
    </Form>
  );
};

export default InvoiceAndTypesForm;
